import {
  Card,
  Divider,
  Illustration,
  List,
  ListItem,
  ListItemText,
  PageHeaderWrapper,
  Text,
  TextSkeleton,
  Title,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { FullScreenDialog } from "@src/appV2/lib/Dialogs";
import React from "react";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";
import { QuizDialogHeader } from "./QuizDialogHeader";

interface QuizRulesDialogProps {
  modalState: UseModalState;
  facilityNotes: Array<{
    isVisibleToWorker: boolean;
    categoryTextVisibleToWorker: string;
    noteId: string | undefined;
    note: string | undefined;
    identifier: string | undefined;
  }>;
  isLoading: boolean;
  onNavigateBack: () => void | undefined;
  onStartQuiz: () => void | undefined;
}

export function QuizRulesDialog(props: QuizRulesDialogProps) {
  const { modalState, facilityNotes, isLoading, onNavigateBack, onStartQuiz } = props;

  const SKELETON_COUNT = 3;

  return (
    <FullScreenDialog skipTopSafeAreaPadding modalState={modalState} variant="tertiary">
      <PageHeaderWrapper variant="tertiary">
        <QuizDialogHeader navigateBack={onNavigateBack} />
      </PageHeaderWrapper>

      <DialogContent>
        <Stack spacing={10}>
          <Stack spacing={5}>
            <Stack alignItems="center">
              <Illustration type="quiz-required" />
            </Stack>
            <Title component="h1" textAlign="center" paddingX={10}>
              Take a brief quiz to book
            </Title>
            <Text variant="h5" textAlign="center" paddingX={10}>
              Answer all questions correctly to pass the quiz and book your shift!
            </Text>
          </Stack>
          <Card outlined elevation={2} sx={{ padding: 5 }}>
            <List>
              {isLoading ? (
                <>
                  {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
                    // eslint-disable-next-line react/jsx-key
                    <>
                      <ListItem>
                        <ListItemText
                          primary={<TextSkeleton variant="h3" width="50%" />}
                          secondary={<TextSkeleton variant="body1" width="100%" />}
                        />
                      </ListItem>
                      {index < SKELETON_COUNT - 1 && <Divider />}
                    </>
                  ))}
                </>
              ) : (
                facilityNotes.map(({ noteId, categoryTextVisibleToWorker, note }, index, array) => (
                  <React.Fragment key={noteId}>
                    <ListItem>
                      <ListItemText primary={categoryTextVisibleToWorker} secondary={note} />
                    </ListItem>
                    {index < array.length - 1 && <Divider />}
                  </React.Fragment>
                ))
              )}
            </List>
          </Card>
        </Stack>
      </DialogContent>
      <DialogFooter orientation="vertical">
        <Button fullWidth disabled={isLoading} onClick={onStartQuiz}>
          Start Quiz
        </Button>
      </DialogFooter>
    </FullScreenDialog>
  );
}
